module.exports = __webpack_public_path__ + "static/media/super_topup_fisdom.f963340d.svg";